export { default } from "./NoResourcesToShare";
